import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::disconnect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:216
* @route '/app/creator/payment/disconnect'
*/
export const disconnect = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disconnect.url(options),
    method: 'delete',
})

disconnect.definition = {
    methods: ["delete"],
    url: '/app/creator/payment/disconnect',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::disconnect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:216
* @route '/app/creator/payment/disconnect'
*/
disconnect.url = (options?: RouteQueryOptions) => {
    return disconnect.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::disconnect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:216
* @route '/app/creator/payment/disconnect'
*/
disconnect.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disconnect.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::disconnect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:216
* @route '/app/creator/payment/disconnect'
*/
const disconnectForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: disconnect.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::disconnect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:216
* @route '/app/creator/payment/disconnect'
*/
disconnectForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: disconnect.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

disconnect.form = disconnectForm

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::connect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:29
* @route '/app/creator/payment/{provider}/connect'
*/
export const connect = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: connect.url(args, options),
    method: 'get',
})

connect.definition = {
    methods: ["get","head"],
    url: '/app/creator/payment/{provider}/connect',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::connect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:29
* @route '/app/creator/payment/{provider}/connect'
*/
connect.url = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { provider: args }
    }

    if (Array.isArray(args)) {
        args = {
            provider: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        provider: args.provider,
    }

    return connect.definition.url
            .replace('{provider}', parsedArgs.provider.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::connect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:29
* @route '/app/creator/payment/{provider}/connect'
*/
connect.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: connect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::connect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:29
* @route '/app/creator/payment/{provider}/connect'
*/
connect.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: connect.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::connect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:29
* @route '/app/creator/payment/{provider}/connect'
*/
const connectForm = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::connect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:29
* @route '/app/creator/payment/{provider}/connect'
*/
connectForm.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::connect
* @see app/Http/Controllers/Creator/PaymentConnectController.php:29
* @route '/app/creator/payment/{provider}/connect'
*/
connectForm.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: connect.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

connect.form = connectForm

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::callback
* @see app/Http/Controllers/Creator/PaymentConnectController.php:42
* @route '/app/creator/payment/{provider}/callback'
*/
export const callback = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

callback.definition = {
    methods: ["get","head"],
    url: '/app/creator/payment/{provider}/callback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::callback
* @see app/Http/Controllers/Creator/PaymentConnectController.php:42
* @route '/app/creator/payment/{provider}/callback'
*/
callback.url = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { provider: args }
    }

    if (Array.isArray(args)) {
        args = {
            provider: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        provider: args.provider,
    }

    return callback.definition.url
            .replace('{provider}', parsedArgs.provider.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::callback
* @see app/Http/Controllers/Creator/PaymentConnectController.php:42
* @route '/app/creator/payment/{provider}/callback'
*/
callback.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::callback
* @see app/Http/Controllers/Creator/PaymentConnectController.php:42
* @route '/app/creator/payment/{provider}/callback'
*/
callback.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: callback.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::callback
* @see app/Http/Controllers/Creator/PaymentConnectController.php:42
* @route '/app/creator/payment/{provider}/callback'
*/
const callbackForm = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::callback
* @see app/Http/Controllers/Creator/PaymentConnectController.php:42
* @route '/app/creator/payment/{provider}/callback'
*/
callbackForm.get = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PaymentConnectController::callback
* @see app/Http/Controllers/Creator/PaymentConnectController.php:42
* @route '/app/creator/payment/{provider}/callback'
*/
callbackForm.head = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

callback.form = callbackForm

const payment = {
    disconnect: Object.assign(disconnect, disconnect),
    connect: Object.assign(connect, connect),
    callback: Object.assign(callback, callback),
}

export default payment